import { Input, Layout, Spin } from 'Components';
import { useFormikContext } from 'formik';
import { EditUserValues } from 'Pages/User/User.types';
import { useTranslation } from 'react-i18next';
import { RoleField, GroupField } from '../../components';
import { useUserTenantRoles } from './ModuleSettings/ModuleSettingsContainer';
import CustomTenantRoleField from 'Pages/User/components/CustomTenantRoleField';
import { useState } from 'react';

interface ProfileProps {
	isProfile: boolean;
}

function Profile({ isProfile }: ProfileProps) {
	const { t } = useTranslation();
	const { values } = useFormikContext<EditUserValues>();
	useUserTenantRoles(values.peakV3Id, !!values.peakV3Id);
	const [customTenantRolesLoading, setCustomTenantRolesLoading] =
		useState(false);
	//const { onDisabled } = useModuleSettings();
	//useResetLmsFieldsOnGroupsChange({ values, resetLmsFields: onDisabled });
	return (
		<>
		{customTenantRolesLoading && <Spin overlay style={{zIndex: 10}}/>}
		<Layout.List fullHeight>
			<Layout.List.ListItem fullHeight>
				<Layout.List.Section title={t('general')}>
					<Input.FormikField
						name="firstName"
						label={t('user.firstName')}
						required
					/>
					<Input.FormikField
						name="lastName"
						label={t('user.lastName')}
						required
					/>
					<Input.FormikField
						name="email"
						label={t('user.email')}
						required
					/>
					<Input.FormikField
						name="cognitoLogin"
						label={t('user.cognitoLogin')}
						disabled
						required
					/>
					<Input.FormikField
						name="phoneNumber"
						label={t('user.phoneNumber')}
					/>
				</Layout.List.Section>
				<Layout.List.Section title={t('user.permission')}>
					<RoleField isProfile={isProfile} />
					<GroupField isProfile={isProfile} />
					{(values.groups?.length ?? 0) > 0 && <CustomTenantRoleField onLoadingChange={setCustomTenantRolesLoading}/>}
				</Layout.List.Section>
			</Layout.List.ListItem>
		</Layout.List>
		</>
	);
}

export default Profile;
